import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  ChallengeDto,
  ChallengeListItemDto,
  CreateChallengeRequest,
  PagedResult,
  UpdateChallengeRequest
} from './challenges-api.types';

@Injectable({ providedIn: 'root' })
export class ChallengesApiService {
  constructor(private readonly http: HttpClient) {}

  getLatestChallenge(): Observable<ChallengeDto | null> {
    return this.http.get<ChallengeDto>('/api/challenges/latest').pipe(
      catchError(() => of(null))
    );
  }

  getChallenges(page = 1, pageSize = 20, search?: string): Observable<PagedResult<ChallengeListItemDto>> {
    const params: Record<string, string> = {
      page: String(page),
      pageSize: String(pageSize)
    };
    if (search?.trim()) params['search'] = search.trim();
    return this.http.get<PagedResult<ChallengeListItemDto>>('/api/challenges', { params });
  }

  getChallengeById(id: string): Observable<ChallengeDto> {
    return this.http.get<ChallengeDto>(`/api/challenges/${encodeURIComponent(id)}`);
  }

  createChallenge(request: CreateChallengeRequest): Observable<ChallengeDto> {
    return this.http.post<ChallengeDto>('/api/challenges', request);
  }

  updateChallenge(id: string, request: UpdateChallengeRequest): Observable<ChallengeDto> {
    return this.http.put<ChallengeDto>(`/api/challenges/${encodeURIComponent(id)}`, request);
  }

  deleteChallenge(id: string): Observable<void> {
    return this.http.delete<void>(`/api/challenges/${encodeURIComponent(id)}`);
  }
}
